// Lišta s cíli nad výpisem kategorie (hned pod H1) — obsah se bere z bannerů
// na pozici „vedle carouselu“ na HP (spravuje se jen tam), cache v sessionStorage.
const MYGOALS_CACHE_KEY = "mygoals-v1";
const MYGOALS_CACHE_TTL = 30 * 60 * 1000;

function myGoalsFromCache() {
    try {
        const cached = JSON.parse(sessionStorage.getItem(MYGOALS_CACHE_KEY));
        if (cached && Date.now() - cached.time < MYGOALS_CACHE_TTL) {
            return cached.data;
        }
    } catch (e) {
        return null;
    }
    return null;
}

function myGoalsParse(html) {
    const $banners = $($.parseHTML(html)).find(".next-to-carousel-banners .banner-wrapper");
    const data = {
        title: $banners.find("h4").first().text().trim(),
        items: [],
    };

    $banners.children("a").each(function () {
        const $link = $(this);
        const $img = $link.find("img").first();
        const $name = $link.find(".extended-banner-title").first().clone();

        $name.find("br").replaceWith(" ");

        data.items.push({
            href: $link.attr("href"),
            img: $img.attr("data-src") || $img.attr("src") || "",
            alt: $img.attr("alt") || "",
            name: $name.html() ? $name.html().trim() : $link.text().trim(),
        });
    });

    return data;
}

function myGoalsRender(data) {
    const $title = $(".category-top .category-title").first();

    if (!data || data.items.length === 0 || $title.length === 0 || $(".mygoals").length) {
        return;
    }

    const currentPath = location.pathname;
    const $goals = $("<nav class='mygoals'></nav>");

    if (data.title) {
        $goals.attr("aria-label", data.title);
    }

    const $list = $("<ul class='mygoals-list'></ul>").appendTo($goals);

    data.items.forEach(function (item) {
        let path = item.href;
        try {
            path = new URL(item.href, location.origin).pathname;
        } catch (e) {
            path = item.href;
        }

        const $link = $("<a class='mygoals-link'></a>").attr("href", item.href);

        if (item.img) {
            $("<img width='28' height='28'>").attr("src", item.img).attr("alt", "").appendTo($link);
        }
        $("<span class='mygoals-name'></span>").html(item.name).appendTo($link);

        if (currentPath.indexOf(path) === 0) {
            $link.addClass("is-active").attr("aria-current", "page");
        }

        $("<li class='mygoals-item'></li>").append($link).appendTo($list);
    });

    $goals.insertAfter($title);

    // Na mobilu je lišta posuvná — aktivní cíl odscrollovat do viditelné části
    const list = $list[0];
    const $active = $list.find(".is-active").closest(".mygoals-item");
    if ($active.length && list.scrollWidth > list.clientWidth) {
        list.scrollLeft = $active[0].offsetLeft - parseFloat($list.css("padding-left"));
    }
}

function myGoalsInit() {
    if (getShoptetDataLayer("pageType") !== "category" || $(".category-top .category-title").length === 0) {
        return;
    }

    const cached = myGoalsFromCache();
    if (cached) {
        myGoalsRender(cached);
        return;
    }

    $.get("/cache/", function (html) {
        const data = myGoalsParse(html);
        try {
            sessionStorage.setItem(MYGOALS_CACHE_KEY, JSON.stringify({ time: Date.now(), data: data }));
        } catch (e) {
            // sessionStorage nemusí být dostupné (anonymní režim) — vykreslí se bez cache
        }
        myGoalsRender(data);
    }, "html");
}

$(document).ready(myGoalsInit);
document.addEventListener("ShoptetDOMPageContentLoaded", myGoalsInit);
